var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"chat"},_vm._l((_vm.messages),function(message){return _c('li',{staticClass:"left clearfix"},[_c('div',{staticClass:"chat-body clearfix"},[_vm._m(0,true),_c('p',[_vm._v(" "+_vm._s(message.message)+" ")])])])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('strong',{staticClass:"primary-font"},[_vm._v(" Usu ")])])
}]

export { render, staticRenderFns }